<template>
  <section class="usage-section" id="enterprise">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">{{ $t('usage.title') }}</h2>
        <p class="section-subtitle">
          {{ $t('usage.subtitle') }}
        </p>
      </div>

      <div class="usage-grid">
        <div class="usage-card enterprise-card">
          <h3 class="usage-title">{{ $t('usage.enterprise') }}</h3>
          <p class="usage-intro">{{ $t('usage.enterpriseIntro') }}</p>
          <ol class="step-list">
            <li>
              <h4>{{ $t('usage.step1') }}</h4>
              <p>{{ $t('usage.step1Desc') }}</p>
            </li>
            <li>
              <h4>{{ $t('usage.step2') }}</h4>
              <p>{{ $t('usage.step2Desc') }}</p>
            </li>
            <li>
              <h4>{{ $t('usage.step3') }}</h4>
              <p>{{ $t('usage.step3Desc') }}</p>
            </li>
            <li>
              <h4>{{ $t('usage.step4') }}</h4>
              <p>{{ $t('usage.step4Desc') }}</p>
            </li>
          </ol>
        </div>

        <div class="usage-card student-card" id="student">
          <h3 class="usage-title">{{ $t('usage.student') }}</h3>
          <p class="usage-intro">{{ $t('usage.studentIntro') }}</p>
          <ol class="step-list">
            <li>
              <h4>{{ $t('usage.studentStep1') }}</h4>
              <p>{{ $t('usage.studentStep1Desc') }}</p>
            </li>
            <li>
              <h4>{{ $t('usage.studentStep2') }}</h4>
              <p>{{ $t('usage.studentStep2Desc') }}</p>
            </li>
            <li>
              <h4>{{ $t('usage.studentStep3') }}</h4>
              <p>{{ $t('usage.studentStep3Desc') }}</p>
            </li>
            <li>
              <h4>{{ $t('usage.studentStep4') }}</h4>
              <p>{{ $t('usage.studentStep4Desc') }}</p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UsageFlowSection'
}
</script>

<style scoped>
.usage-section {
  padding: 5rem 0;
  background:
    radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.16) 0, transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(168, 85, 247, 0.22) 0, transparent 55%),
    #020617;
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #F9FAFB;
  margin-bottom: 0.75rem;
}

.section-subtitle {
  font-size: 1rem;
  color: #9CA3AF;
  max-width: 640px;
  margin: 0 auto;
}

.usage-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
}

.usage-card {
  border-radius: 20px;
  padding: 2rem 2rem 1.75rem;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.18) 0, transparent 55%),
              radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.26) 0, transparent 55%),
              rgba(15, 23, 42, 0.96);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.9);
}

.usage-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #F9FAFB;
  margin-bottom: 0.5rem;
}

.usage-intro {
  font-size: 0.95rem;
  color: #CBD5F5;
  margin-bottom: 1.25rem;
}

.step-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.step-list h4 {
  font-size: 0.95rem;
  font-weight: 600;
  color: #E5E7EB;
  margin-bottom: 0.2rem;
}

.step-list p {
  font-size: 0.85rem;
  color: #9CA3AF;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .usage-section {
    padding: 4rem 0;
  }

  .container {
    padding: 0 1rem;
  }

  .usage-grid {
    grid-template-columns: 1fr;
  }

  .usage-card {
    padding: 1.75rem 1.5rem 1.5rem;
  }

  .section-title {
    font-size: 1.7rem;
  }
}
</style>

